import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { SITE_URL } from '../i18n/routes'

/**
 * RedirectRoute handles 301-equivalent permanent redirects.
 * Updates browser history cleanly without back-button traps, sets canonical URL,
 * and sets meta-refresh tag for pre-rendering/crawlers.
 */
export default function RedirectRoute({ to }) {
  const location = useLocation()
  const targetUrl = `${SITE_URL}${to}`

  useEffect(() => {
    // Scroll to top on redirect
    window.scrollTo(0, 0)
  }, [to])

  return (
    <>
      <Helmet>
        <title>Omdirigerer... / Redirecting...</title>
        <meta httpEquiv="refresh" content={`0;url=${to}`} />
        <link rel="canonical" href={targetUrl} />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Navigate to={to} replace />
    </>
  )
}
